import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { RootState } from '../store/rootReducer';

const useAppSelector = useSelector as TypedUseSelectorHook<RootState>;
export default useAppSelector;
